import API from "@/services/api";

const ATTACHMENTS_ENDPOINT = "/document-repository/attachments/";
const DOWNLOAD_ENDPOINT = `${ATTACHMENTS_ENDPOINT}download/`;

export const fetchDocumentRepositoryFilters = (type: string) =>
  API.get<unknown>({
    endpoint: "/filter/params",
    versions: [2],
    searchParams: `?fields=cups,addresses,contracts,vats&type=${encodeURIComponent(type)}`,
  }).then(({ promise }) => promise.data);

export const fetchDocumentRepositoryAttachments = (
  filters: string,
  offset: number,
  limit: number,
) =>
  API.get<unknown>({
    endpoint: ATTACHMENTS_ENDPOINT,
    versions: [2],
    searchParams: `?offset=${offset}&limit=${limit}&filter=[${filters}]`,
  }).then(({ promise }) => promise.data);

export const downloadDocumentRepositoryAttachment = (attachmentId: string) =>
  API.get<Blob>({
    endpoint: DOWNLOAD_ENDPOINT,
    versions: [2],
    config: {
      params: { attachment_ids: attachmentId },
      responseType: "blob",
    },
  }).then(({ promise }) => promise);

export const downloadDocumentRepositoryAttachments = (attachmentIds: string[]) =>
  API.post<Blob, { attachment_ids: string[] }>({
    endpoint: DOWNLOAD_ENDPOINT,
    versions: [2],
    data: { attachment_ids: attachmentIds },
    config: { responseType: "blob" },
  }).then(({ promise }) => promise);
